/**
 * Collection/search card swatches — preview on hover/focus, navigate on click.
 */
(() => {
  const cards = document.querySelectorAll('[data-product-card]');
  if (!cards.length) return;

  const siblingUrl = (btn) => {
    const base = btn.dataset.siblingUrl;
    const variantId = btn.dataset.siblingVariantId;
    if (!base) return '';
    return variantId ? `${base}?variant=${variantId}` : base;
  };

  const swapCardImage = (imageEl, src, alt) => {
    if (!imageEl || !src) return;
    imageEl.removeAttribute('srcset');
    imageEl.removeAttribute('sizes');
    imageEl.src = src;
    imageEl.alt = alt || '';
  };

  const resetCardImage = (imageEl) => {
    if (!imageEl) return;
    const src = imageEl.dataset.defaultSrc;
    if (!src) return;
    imageEl.src = src;
    if (imageEl.dataset.defaultSrcset) {
      imageEl.srcset = imageEl.dataset.defaultSrcset;
      imageEl.sizes = '(min-width: 1280px) 20vw, (min-width: 1024px) 25vw, 50vw';
    }
    imageEl.alt = imageEl.dataset.defaultAlt || '';
  };

  const showPrimaryLayer = (card) => {
    if (typeof card._showPrimaryImage === 'function') {
      card._showPrimaryImage();
    }
  };

  cards.forEach((card) => {
    const triggers = card.querySelectorAll('[data-swatch-trigger]');
    if (!triggers.length) return;

    const swatchRoot = card.querySelector('[data-color-swatches]');
    const linkEls = card.querySelectorAll('[data-card-link]');
    const titleEl = card.querySelector('[data-card-title]');
    const priceValueEl = card.querySelector('[data-card-price-value]');
    const fromLabelEl = card.querySelector('[data-card-from-label]');
    const compareEl = card.querySelector('[data-card-compare]');
    const imageEl = card.querySelector('[data-card-image]');
    const valueEl = card.querySelector('[data-swatch-value]');
    const sizeHintEl = card.querySelector('[data-card-size-hint]');
    const defaultTrigger = card.querySelector('[data-swatch-trigger][data-active="true"]');

    const apply = (btn) => {
      const url = siblingUrl(btn);
      if (!url) return;

      card.setAttribute('data-swatch-preview', '');

      linkEls.forEach((a) => {
        a.href = url;
      });
      card.dataset.productUrl = url;

      if (titleEl && btn.dataset.siblingTitle) {
        titleEl.textContent = btn.dataset.siblingTitle;
      }

      if (valueEl && btn.dataset.siblingValue) {
        valueEl.textContent = btn.dataset.siblingValue;
      }

      const showFrom = btn.dataset.siblingPriceFrom === 'true';
      if (fromLabelEl) {
        fromLabelEl.classList.toggle('hidden', !showFrom);
      }

      if (priceValueEl && btn.dataset.siblingPriceMin) {
        priceValueEl.textContent = btn.dataset.siblingPriceMin;
      }

      if (sizeHintEl) {
        const hint = btn.dataset.siblingSizeHint || '';
        sizeHintEl.textContent = hint;
        sizeHintEl.classList.toggle('hidden', hint.length === 0);
      }

      if (compareEl) {
        const compare = btn.dataset.siblingCompare || '';
        if (compare && !showFrom) {
          compareEl.textContent = compare;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hidden');
        }
      }

      swapCardImage(
        imageEl,
        btn.dataset.siblingImage,
        btn.dataset.siblingImageAlt || btn.dataset.siblingTitle
      );
      showPrimaryLayer(card);

      triggers.forEach((t) => {
        const active = t === btn;
        t.dataset.active = active ? 'true' : 'false';
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    triggers.forEach((btn) => {
      btn.addEventListener('mouseenter', () => apply(btn));
      btn.addEventListener('focus', () => apply(btn));
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        apply(btn);
        const url = siblingUrl(btn);
        if (url) window.location.assign(url);
      });
    });

    if (swatchRoot && defaultTrigger) {
      swatchRoot.addEventListener('mouseleave', () => {
        card.removeAttribute('data-swatch-preview');
        apply(defaultTrigger);
        resetCardImage(imageEl);
        showPrimaryLayer(card);
      });
    }
  });
})();
